import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { of } from 'rxjs/observable/of';
import { concat } from 'rxjs/observable/concat';
import { type ActionsObservable } from 'redux-observable';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { getCloudId } from '../context/selectors';
import { getProjectId } from '../project/selectors';
import { startConfluenceActivation$ } from './requests';
import { START_ACTIVATION, updateConfluenceActivationStatus } from '../actions/activate-confluence';
import { type Store } from 'redux';
import { type State } from '../types';
import { showActivationErrorFlag } from '../actions';

export default (
	action$: ActionsObservable<ReturnType<typeof startConfluenceActivation$>>,
	store: Store<State>,
) =>
	action$.ofType(START_ACTIVATION).switchMap(() => {
		const state = store.getState();
		const projectId = getProjectId(state);
		const cloudId = getCloudId(state);

		return startConfluenceActivation$(cloudId, {
			projectId,
		})
			.mergeMap((response) => {
				if (!response?.started) {
					throw new Error('Could not start confluence activation.');
				}
				fetchSuccess('confluence.activate.start');
				return of(
					updateConfluenceActivationStatus({
						status: 'activating',
					}),
				);
			})
			.catch((error) => {
				fetchFailed('confluence.activate.start', error);
				return concat([
					showActivationErrorFlag(),
					updateConfluenceActivationStatus({
						status: 'not-allowed',
					}),
				]);
			});
	});
